import { AttachSvg } from "../../assets";
import CustomTooltip from "../Tooltip/CustomTooltip";

const AttachDropdown = ({ fileInputRef, filesLength }) => {

  const isDisabled = false;

  const handleFileInputClick = () => {
    if (isDisabled) return;
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const tooltipText = "Files attached are loaded in the photon memory for processing.";

  return (
    <div className="relative">
      <CustomTooltip content={tooltipText} side="top" align="center">
        <button
          type="button"
          onClick={handleFileInputClick}
          disabled={isDisabled}
          aria-label="Attach files"
          className={`flex justify-center items-center w-8 h-8 rounded-full transition-[box-shadow,background-color] duration-300
            hover:shadow-[0_0_0_0.5px_#6D808D4D]
            hover:bg-fill-navigation-hover hover:dark:bg-fill-navigation-hover-dark
            ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
        >
          <AttachSvg className="fill-ink-ink-alternate dark:fill-ink-white" />
        </button>
      </CustomTooltip>
    </div>
  );
};

export default AttachDropdown;
